module.exports = __webpack_public_path__ + "img/3WetterTaft.02451de9.jpg";